/* Reya cart — free-shipping progress animation, cart upsell (recommendations), quick add.
   Works alongside Dawn's cart-drawer.js / cart.js (which re-render the drawer via section rendering). */
(() => {
  if (window.__rrCart) return;
  window.__rrCart = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- quick add (shared with rr-product.js) ---------- */
  window.ReyaCart =
    window.ReyaCart ||
    {
      async add(items, btn) {
        const drawer = document.querySelector('cart-drawer');
        const body = { items };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); btn.disabled = true; }
        try {
          const res = await fetch(`${(window.routes && routes.cart_add_url) || root + 'cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rr-cart', cartData: data });
          }
          if (drawer && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else window.location.href = (window.routes && routes.cart_url) || root + 'cart';
          return data;
        } catch (e) {
          window.Reya && Reya.toast && Reya.toast(e.message || (window.cartStrings && cartStrings.error) || 'Error');
          return null;
        } finally {
          if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); btn.disabled = false; }
        }
      },
    };

  if (!window.__rrAddBound) {
    window.__rrAddBound = true;
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rr-add]');
      if (!b) return;
      e.preventDefault();
      window.ReyaCart.add([{ id: +b.dataset.rrAdd, quantity: 1 }], b);
    });
  }

  /* ---------- save for later (wishlist + remove line) & click-to-play video ---------- */
  document.addEventListener('click', (e) => {
    const save = e.target.closest('[data-rr-save-later]');
    if (save) {
      e.preventDefault();
      const W = window.ReyaWishlist;
      if (W && !W.has(save.dataset.rrSaveLater)) W.toggle(save.dataset.rrSaveLater);
      const RS = window.ReyaSettings || {};
      window.Reya && Reya.toast && Reya.toast(RS.wishlistAdded || '', RS.wishlistUrl ? { url: RS.wishlistUrl, label: RS.wishlistView } : null, { icon: 'heart' });
      const rm = document.getElementById(`Remove-${save.dataset.index}`) || document.getElementById(`CartDrawer-Remove-${save.dataset.index}`);
      rm && rm.click();
      return;
    }
    const play = e.target.closest('[data-rr-play]');
    if (play) {
      const v = play.parentElement.querySelector('video');
      if (!v) return;
      v.controls = true;
      v.play().catch(() => {});
      play.hidden = true;
    }
  });

  /* ---------- gift note counter + upsell collapse (mobile) ---------- */
  document.addEventListener('input', (e) => {
    const t = e.target.closest && e.target.closest('[data-rr-note]');
    if (!t) return;
    const c = t.closest('.rr-giftnote') && t.closest('.rr-giftnote').querySelector('[data-rr-note-count]');
    if (c) c.textContent = t.value.length;
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rr-upsell-toggle]');
    if (!b) return;
    const open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open);
    const up = b.closest('rr-cart-upsell');
    up && up.classList.toggle('is-collapsed', !open);
  });

  /* ---------- free-shipping bar: animate from previous ratio ---------- */
  if (!customElements.get('rr-freeship')) {
    customElements.define(
      'rr-freeship',
      class extends HTMLElement {
        connectedCallback() {
          const to = parseFloat(this.dataset.ratio) || 0;
          const from = typeof window.__rrFreePrev === 'number' ? window.__rrFreePrev : 0;
          window.__rrFreePrev = to;
          if (reduce || from === to) return;
          this.style.setProperty('--rr-ratio', from);
          this.classList.add('is-static');
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              this.classList.remove('is-static');
              this.style.setProperty('--rr-ratio', to);
            })
          );
        }
      }
    );
  }

  /* ---------- cart upsell ---------- */
  const cache = (window.__rrUpsellCache = window.__rrUpsellCache || {});
  if (!customElements.get('rr-cart-upsell')) {
    customElements.define(
      'rr-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-rr-upsell-list]');
          if (!this.list || !this.dataset.url) return;
          const key = this.dataset.url + '|' + this.dataset.key;
          if (cache[key] !== undefined) return this.apply(cache[key]);
          fetch(this.dataset.url)
            .then((r) => (r.ok ? r.text() : ''))
            .then((t) => {
              const doc = new DOMParser().parseFromString(t, 'text/html');
              const ul = doc.querySelector('[data-rr-upsell-items]');
              const html = ul && ul.children.length ? ul.innerHTML : '';
              cache[key] = html;
              this.apply(html);
            })
            .catch(() => (cache[key] = ''));
        }
        apply(html) {
          if (html) this.list.innerHTML = html;
          const max = +this.dataset.limit || 0;
          if (max) Array.from(this.list.children).slice(max).forEach((el) => el.remove());
          this.hidden = !this.list.children.length;
        }
      }
    );
  }
})();
